import { render, staticRenderFns } from "./FriendRelationship.vue?vue&type=template&id=801cd44a&scoped=true&"
import script from "./FriendRelationship.vue?vue&type=script&lang=js&"
export * from "./FriendRelationship.vue?vue&type=script&lang=js&"
import style0 from "./FriendRelationship.vue?vue&type=style&index=0&id=801cd44a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801cd44a",
  null
  
)

export default component.exports